export default class PriceRange extends HTMLElement {
  constructor() {
    super()

    this.$inputGte = this.querySelector("[name='filter.v.price.gte']")
    this.$inputLte = this.querySelector("[name='filter.v.price.lte']")

    this.$priceRange = this.querySelector('[data-block="range"]')
    this.priceRange = null
    this.divideBy = 100;
    if(Shopify.shop === 'satorisan-row.myshopify.com'){
      this.divideBy = 1
    }
    this.state = {
      defaultMin: parseFloat(this.$inputGte?.min || 0),
      defaultMax: parseFloat(this.$inputLte?.max || 300),

      min: parseFloat(this.$inputGte?.value * this.divideBy || this.$inputGte?.min),
      max: parseFloat(this.$inputLte?.value * this.divideBy || this.$inputLte?.max),
    }
  }

  setState(newState) {
    this.state = {
      ...this.state,
      ...newState,
    }
    this.render()
  }

  connectedCallback() {
    this.initSlider()
    this.priceRange.on("change.one", (args) => this.handleChange(args))
    if(this.$inputGte && !this.$inputGte.disabled ){
      this.handleChange([this.state.min, this.state.max]);
    } 
  }

  disconnectedCallback() {
    this.priceRange.on("change.one", (args) => this.handleChange(args))
  }

  handleChange([min, max]) {
    this.setState({
      min:parseInt(min / this.divideBy),
      max:parseInt(max / this.divideBy)
    })
  }

  initSlider() {
    this.priceRange = noUiSlider.create(this.$priceRange, {
      start: [this.state.min, this.state.max],
      step: 10,
      connect: true,
      range: {
        min: this.state.defaultMin,
        max: this.state.defaultMax,
      },
      format: {
        from: (value) => Math.round(value),
        to: (value) => Math.round(value),
      },
      tooltips: {
        from: (value) => {
          if (Shopify.currency.active === "EUR") {
            value = value / 100
          }
          return theme.moneyFormat.replace(/{{(.*?)}}/g, value.toFixed(0))
        },
        to: (value) => {
          if (Shopify.currency.active === "EUR") {
            value = value / 100
          }
          return theme.moneyFormat.replace(/{{(.*?)}}/g, value.toFixed(0))
        },
      },
    })

    // mergeTooltips(this.$priceRange, 15, " - ", theme.moneyFormat, /{{(.*?)}}/g);
  }

  render() {
    this.$inputGte.removeAttribute("disabled")
    this.$inputLte.removeAttribute("disabled")

    this.$inputGte.value = this.state.min
    this.$inputLte.value = this.state.max
  }
}
